<template>
  <v-card
    flat
    color="white"
    light
    style="height: 100%"
    rounded="xl"
    class="d-flex flex-column justify-space-between overflow-hidden"
  >
    <div class="white">
      <v-img
        :height="$vuetify.breakpoint.mdAndDown ? '200px' : '250px'"
        :src="
          product.resim
            ? $baseUrlAPI + '' + product.resim
            : require('@/assets/images/misc/not-image.jpg')
        "
      >
      </v-img>

      <v-row class="px-3 pt-3" dense>
        <v-col cols="12" md="6">
          <v-chip color="primary" small>
            {{ product.urun_kodu }}
          </v-chip>
        </v-col>
        <v-col v-if="userData.role !== 'COMUSR'" cols="12" md="6">
          <h5 class="text-body-1 font-weight-bold text-md-right">
            {{ product.satis_fiyati | currency }}
          </h5>
        </v-col>

        <v-col cols="12">
          <v-btn
            depressed
            outlined
            rounded
            small
            block
            :loading="stokLoading"
            :color="stokRenk"
            @click="checkStockFn(product.id, product.birim)"
          >
            {{ stokText }}
          </v-btn>
        </v-col>
      <!--   v-if="hasInfo"  -->
        <v-col v-if="hasInfo" cols="12">
          <v-btn
            depressed
            outlined
            rounded
            small
            block
            color="info"
            class="btn-info-wrap"
            @click="isInfoDialog = true"
          >
            <v-icon small class="mr-2">{{ icons.mdiInformation }}</v-icon>
            {{ $vuetify.breakpoint.xsOnly ? 'İçerik / Alerjen' : 'İçerik / Alerjen Bilgisi' }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="px-3 pb-6">
        <v-col cols="12">
          <h3 class="text-body-2 font-weight-medium" style="text-wrap: balance">
            {{ product.baslik }}
          </h3>
        </v-col>
      </v-row>
    </div>
    <div class="pa-3">
      <v-row dense>
        <v-col cols="12">
          <v-card class="mb-2 pl-3 overflow-hidden" outlined rounded="pill">
            <Counter
              :birim="product.birim || 'AD'"
              :birim-ritim="1"
              bg-color="transparent"
              button-color="counter"
              :dark="false"
              :light="true"
              :status="false"
              @selected="selected"
            ></Counter>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-btn
            depressed
            block
            x-large
            style="height: 55.5px !important"
            color="night"
            rounded
            :loading="loading"
            class="text-capitalize white--text px-0"
            @click="
              addToBasket(
                product.plants,
                product.baslik,
                product.id,
                count,
                product.birim,
                $route.params.type === 'mamul' ? 'Mamül' : 'Sarf'
              )
            "
          >
            Sepete At
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <v-dialog
      v-model="isInfoDialog"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="640"
      transition="dialog-bottom-transition"
    >
      <v-card rounded="xl" class="overflow-hidden">
        <div class="dialog-image-wrap mt-3">
          <v-img
            :src="
              product.resim
                ? $baseUrlAPI + '' + product.resim
                : require('@/assets/images/misc/not-image.jpg')
            "
            :height="$vuetify.breakpoint.xsOnly ? '160px' : ($vuetify.breakpoint.mdAndDown ? '200px' : '220px')"
            contain
            class="rounded-xl dialog-image"
            eager
            transition="none"
          >
          </v-img>
        </div>

        <v-card-title class="py-2 px-4">
          <div class="w-100">
            <div class="d-flex align-center mb-1">
              <v-chip x-small color="primary" label class="ml-0">{{ product.urun_kodu }}</v-chip>
            </div>
            <div class="dialog-title-full">{{ product.baslik }}</div>
          </div>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <v-row dense>
            <v-col v-if="product.icindekiler" cols="12">
              <div class="d-flex align-start mb-2">
                <v-icon color="primary" class="mr-2">{{ icons.mdiFoodVariant }}</v-icon>
                <div class="text-subtitle-1 font-weight-bold">İçindekiler</div>
              </div>
              <div class="text-body-2" style="white-space: pre-line; line-height: 1.5;">
                {{ product.icindekiler }}
              </div>
            </v-col>

            <v-col v-if="product.alerjentext" cols="12">
              <v-divider class="my-4"></v-divider>
              <div class="d-flex align-start mb-2">
                <v-icon color="error" class="mr-2">{{ icons.mdiAlertCircleOutline }}</v-icon>
                <div class="text-subtitle-1 font-weight-bold">Alerjen Uyarıları</div>
              </div>
              <div class="text-body-2" style="white-space: pre-line; line-height: 1.5;">
                {{ product.alerjentext }}
              </div>
            </v-col>

            <v-col v-if="!product.icindekiler && !product.alerjentext" cols="12">
              <div class="text-body-2 white--text text--darken-1">
                Bu ürün için içerik veya alerjen bilgisi bulunamadı.
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="isInfoDialog = false">Kapat</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import useAppConfig from "@core/@app-config/useAppConfig";
import useVuetify from "@core/utils/vuetify";
import { postData } from "@utils";

import Counter from "@/components/CounterTo.vue";
import store from "@/store";
import {
  mdiAccountOutline,
  mdiCartPlus,
  mdiChevronDown,
  mdiHelpCircleOutline,
  mdiInformation,
  mdiAlertCircleOutline,
  mdiFoodVariant,
  mdiLockOpenOutline,
  mdiShareVariantOutline,
  mdiStarOutline,
  mdiTrendingUp,
  mdiRefresh,
} from "@mdi/js";
import { computed, ref } from "@vue/composition-api";
import Vue from "vue";

export default {
  components: {
    Counter,
  },
  props: {
    product: {
      type: Object,
      default: null,
    },
    index: {
      type: Number,
      default: 1,
    },
  },
  emits: ["info"],
  setup(props, { emit }) {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const { rootThemeClasses } = useVuetify();

    const isCardDetailsVisible = false;
    const { isDark, menuIsVerticalNavMini } = useAppConfig();
    const rating = ref(5);
    const count = ref(1);
    const counts = computed(() => Array.from({ length: 100 }, (_, i) => i + 1));

    const info = (product, qty, birim) => {
      emit("addInfo", { product, qty, birim });
    };
    const selected = (restaurant) => {
      count.value = restaurant.value;
    };
    const stokText = ref("Stok Göster");
    const stokStart = ref(true);
    const stokLoading = ref(false);
    const checkStockFn = async (id, birim = "AD") => {
      try {
        stokStart.value = true;
        stokLoading.value = true;
        await postData({
          method: "getMaterialStock",
          id,
        }).then((response) => {
          if (response.error) {
            stokText.value = "Hata";
            return;
          }

          stokText.value = response.availqty + " " + birim;
        });
      } catch (err) {
        stokText.value = "Hata";
      } finally {
        stokLoading.value = false;
      }
    };

    const stokRenk = computed(() => {
      let result = null;
      if (stokText.value === "Stok Göster") result = null;
      else if (stokText.value === "Hata") result = "error";
      else if (stokText.value.slice(0, 1) === "0") result = "warning";
      else result = "success";
      return result;
    });

    const isInfoDialog = ref(false);
    //ALERJEN -  alerjen bilgisi ve içerik bilgisi gösterilmeyecek onay gelmediği için false yapıldı GMZ 10.12.2025
    const hasInfo = computed(() => {
      return Boolean(props.product && (props.product.icindekiler || props.product.alerjentext));
    });
    return {
      stokRenk,
      checkStockFn,
      stokText,
      stokLoading,
      stokStart,
      rootThemeClasses,
      isCardDetailsVisible,
      rating,
      selected,
      count,
      counts,
      isDark,
      menuIsVerticalNavMini,
      info,
      userData,
      isInfoDialog,
      hasInfo,
      // icons
      icons: {
        mdiInformation,
        mdiAlertCircleOutline,
        mdiFoodVariant,
        mdiChevronDown,
        mdiCartPlus,
        mdiShareVariantOutline,
        mdiLockOpenOutline,
        mdiStarOutline,
        mdiAccountOutline,
        mdiTrendingUp,
        mdiRefresh,

        mdiHelpCircleOutline,
      },
    };
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    addBasket(plant, product, id, count, birim, kategori) {
      store
        .dispatch("postMethod", { method: "getAllBasket" })
        .then((response) => {
          store
            .dispatch("app-order/fetchAddToBasket", {
              method: "addToBasket",
              uid: id,
              qty: count,
              plant,
            })
            .then((response) => {
              this.loading = false;
              if (response.error) {
                Vue.swal({
                  title: "Hata",
                  html: response.detail.msg,
                  icon: "error",
                  timer: 2000,
                  background: "#FF4C51",

                  timerProgressBar: true,
                  showConfirmButton: false,
                });
              } else {
                this.info(product, count, birim);
                store.dispatch("refreshRiskLimit");
              }
            });
        });
    },
    baslikSplit(val, index) {
      let result;
      if (val.split("(").length > 1) {
        if (index === 0) {
          result = val.split("(")[index].slice(0, -1);
        } else {
          result = val.split("(")[index].slice(0, -1);
        }
      } else if (index === 0) {
        result = val;
      }

      return result;
    },
    async addToBasket(plants, product, id, count, birim, kategori) {
      this.loading = true;

      this.addBasket("01", product, id, count, birim, kategori);

      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
@import "~@core/preset/preset/mixins.scss";

.chip-rotate {
  transform: rotate(90deg) translateY(0px) translateX(-16px);
  transform-origin: left bottom;
}
.chip-content {
  .v-chip__content {
    width: 100%;
    justify-content: space-between !important;
  }
}
// Mobile wrap for info button to avoid overflow
.btn-info-wrap {
  white-space: normal !important;
  line-height: 1.2 !important;
}
// Dialog image wrapper to create equal padding and limit width
.dialog-image-wrap {
  padding: 16px;
}
.dialog-image {
  max-width: 520px;
  margin-left: auto;
  margin-right: auto;
  display: block;
  overflow: hidden; // ensure image respects rounded corners
  border-radius: 0; // keep square edges unless rounded on v-img
}
.dialog-title {
  font-weight: 700;
  font-size: 1rem;
  max-width: 75%;
}
.dialog-title-full {
  font-weight: 700;
  font-size: 1rem;
  white-space: normal;
  line-height: 1.3;
}
@media screen and (max-width: 599px) {
  .dialog-image-wrap {
    padding: 12px;
  }
  .dialog-image {
    max-width: 90vw;
  }
  .dialog-title {
    max-width: 65%;
  }
  .dialog-title-full {
    font-size: 0.95rem;
  }
}
// membership pricing
@include theme--child(memberpricing-bg) using ($material) {
  background-color: rgba(
    map-deep-get($material, "primary-shade"),
    map-deep-get($material, "states", "hover")
  );
}
</style>
